import { RouteComponentProps } from '@reach/router';
import { Link } from 'gatsby';
import React from 'react';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';

import notFoundLogo from '../../assets/images/freeCodeCamp-404.svg';
import { randomQuote } from '../../utils/get-words';
import { Spacer } from '../helpers';

import './404.css';

const FourOhFour = (_props: RouteComponentProps): JSX.Element => {
  const quote = randomQuote();

  return (
    <div className='notfound-page-wrapper'>
      <img
        alt="freeCodeCamp 404 Not Found"
        src={notFoundLogo}
        data-playwright-test-label='not-found-image'
      />
      <Spacer size='medium' />
      <h1 id='content-start' data-playwright-test-label='not-found-heading'>
        That page doesn't exist.
      </h1>
      <Spacer size='medium' />
      <div>
        <p data-playwright-test-label='heres-quote-paragraph'>
          Here's a random quote:
        </p>
        <Spacer size='medium' />
        <blockquote
          className='quote-wrapper'
          data-playwright-test-label='quote-wrapper'
        >
          <p className='quote' data-playwright-test-label='quote-content'>
            {quote.quote}
          </p>
          <p className='author' data-playwright-test-label='author-name'>
            - {quote.author}
          </p>
        </blockquote>
      </div>
      <Spacer size='large' />
      <Link
        className='btn btn-cta'
        to='/learn'
        data-playwright-test-label='view-curriculum-btn'
      >
        View Curriculum
      </Link>
    </div>
  );
};

export default FourOhFour;
